import { render, staticRenderFns } from "./recordStatistic.vue?vue&type=template&id=21f5678c&scoped=true&"
import script from "./recordStatistic.vue?vue&type=script&lang=js&"
export * from "./recordStatistic.vue?vue&type=script&lang=js&"
import style0 from "./recordStatistic.vue?vue&type=style&index=0&id=21f5678c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5678c",
  null
  
)

export default component.exports